module.exports = __webpack_public_path__ + "media/pages/press/downloads/LifeTime_Produkt-b6087e4d905935bf4c7ba26499ce8bc0.jpg";